















































import { Vue, Component, Prop } from 'vue-property-decorator';
import VideoPopup from './VideoPopup.vue';
@Component({
    components: {}
})
export default class MediaDownloadVideoItem extends Vue {
    [x: string]: any;
    @Prop()
    imageData!: any;

    private play() {
        if (!this.imageData.CanPlay) {
            return;
        }

        this.$modal.show(
            VideoPopup,
            {
                videoUrl: this.imageData.Link1,
                title: this.imageData.Filename
            },
            {
                adaptive: false,
                height: '90%',
                width: '90%',
                maxWidth: 1500,
                scrollable: false
            }
        );
    }
}
